import React from 'react';

import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';

import { useSelector } from 'react-redux';

import { selectBusinessLocations } from 'selectors';

import { ServiceItemLocationSettingPropType } from './ServiceItemLocationSettings.types';
import { getNewSettings, getSettingForLocation } from './ServiceItemLocationSettings.utils';
import TableRow from './components/TableRow';

import './ServiceItemLocationSettings.scss';

const propTypes = {
  settings: PropTypes.arrayOf(ServiceItemLocationSettingPropType).isRequired,
  onChange: PropTypes.func.isRequired,
};

const defaultProps = {};

export default function ServiceItemLocationSettings({ settings, onChange: onChangeProp }) {
  const locations = useSelector((state) => selectBusinessLocations(state, { camelCase: true }));

  const isMultiLocation = locations.length > 1;

  if (!isMultiLocation) {
    return null;
  }

  function onChange(e, target) {
    const { locationId, name, checked: value } = target;

    const newSettings = getNewSettings(settings, locationId, name, value);
    const newTarget = { ...target, value: newSettings };

    onChangeProp({ ...e, target: newTarget }, newTarget);
  }

  return (
    <Table celled className="service-item-location-settings-table">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width={8}>Location</Table.HeaderCell>
          <Table.HeaderCell width={4}>Active At Location</Table.HeaderCell>
          <Table.HeaderCell width={4}>Display On Location Page</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {locations.map((location) => {
          const { id } = location;
          const setting = getSettingForLocation(settings, id);

          return <TableRow key={id} location={location} setting={setting} onChange={onChange} />;
        })}
      </Table.Body>
    </Table>
  );
}

ServiceItemLocationSettings.propTypes = propTypes;
ServiceItemLocationSettings.defaultProps = defaultProps;
